import React, {PropTypes} from 'react';
import StandardModal from 'shared/StandardModal.jsx';
import Submitting from 'shared/Submitting.jsx';
import ErrorListContainer from 'shared/error/ErrorListContainer.jsx';
import {formatCurrency} from 'shared/util/formatCurrency';
Number.prototype.formatCurrency = formatCurrency;

const DeactivateModal = ({
  id,
  fee,
  description,
  eventName,
  visible,
  submitting,
  onCancelClick,
  onDeactivateClick
}) => (
  <StandardModal
    visible={visible}
    title="Add On Fee"
    onCloseClick={onCancelClick}
  >
    <ErrorListContainer />
    <div className="alert alert-warning text-center">
      <div>{'The following fee will no longer be charged.'}</div>
      <br />
      <strong className="flex space-around">
        <span>{eventName}</span>
        <span>{`$${fee.formatCurrency(2)}`}</span>
        <span>{description}</span>
      </strong>
    </div>
    <hr />
    <div className="text-right">
      <button
        type="button"
        className="btn btn-link"
        disabled={submitting}
        onClick={onCancelClick}
      >{`Cancel`}</button>
      {` `}
      <button
        type="button"
        className="btn btn-primary btn-lg"
        disabled={submitting}
        onClick={() => onDeactivateClick(id)}
      >{submitting ? <Submitting /> : null} {'Deactivate'}</button>
    </div>
  </StandardModal>
);

DeactivateModal.propTypes = {
  id: PropTypes.string,
  fee: PropTypes.number,
  description: PropTypes.string,
  eventName: PropTypes.string,
  visible: PropTypes.bool,
  submitting: PropTypes.bool,
  onCancelClick: PropTypes.func,
  onDeactivateClick: PropTypes.func
};

DeactivateModal.defaultProps = {
  id: '',
  fee: 0,
  description: '',
  eventName: '',
  visible: false,
  submitting: false
};

export default DeactivateModal;



// WEBPACK FOOTER //
// ./src/features/tournament/fees/DeactivateModal.jsx